import { useEffect, useState } from 'react';
import { isBrowser } from '../utils';
export const useIsBrowser = ({ ssr = true } = {}) => {
    const [isClient, setIsClient] = useState(() => {
        if (ssr)
            return false;
        return isBrowser;
    });
    useEffect(() => {
        setIsClient(isBrowser);
    }, []);
    return isClient;
};
//# sourceMappingURL=useIsBrowser.js.map